<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        props: {
            component_id: {
                default(){
                    return 'frame_colour_internal';
                }
            },
            frameMaterial: {
                required: false,
                default(){
                    return '1';
                }
            },
            title: {
                default(){
                    return null;
                }
            },
            frameColourExternal: {
                required: true,
            },
            slab: {
                required: true,
            },
            profile: {
                required: false,
                default() {
                    return 0;
                }
            },
            doorRange: {
                required: false,
                default() {
                    return 0;
                }
            },
            colourRange: {
                required: false,
                default() {
                    return 0;
                }
            },
            slabCassette: {
              required: false,
              default() {
                return 0;
              }
            },
            category: {
                required: false,
                default() {
                    return 0;
                }
            },
        },
        computed: {
            thumbURL(){
                return '/thumb/frame-colour-' + this.frameMaterial + '/';
            },
            passed_filter(){
                return this.variable_ready(this.frameMaterial, this.frameColourExternal, this.profile, this.slab, this.doorRange, this.colourRange);
            },
            url(){
                return '/api/options/' + this.fabricator + '/frame-colour-internal?frame_external_colour=' + this.frameColourExternal + '&slab=' + this.slab + '&profile=' + this.profile + '&frame_material=' + this.frameMaterial + '&door_range=' + this.doorRange + '&colour_range=' + this.colourRange + '&slab_cassette=' + this.slabCassette + '&category=' + this.category;
            },
            cache_key(){
                return '_' + this.frameColourExternal + '_' + this.slab + '_' + this.profile + '_' + this.frameMaterial + '_' + this.doorRange + '_' + this.colourRange + '_' + this.slabCassette + '_' + this.category;
            },
        },
        watch: {
          'cache_key': function (val, oldVal) {
            this.update_options();
          },
        },
    }
</script>
